export const emit =
    (event: string) => (emit: (e: string, v: any) => void) => (v: any) => {
        let val = v;
        if (typeof v === 'object') {
            try {
                val = v.target.value;
            } catch (e) {
                // ignored
            }
        }
        emit(event, val);
    };

export const emitChange = emit('change');

export const emitInput = emit('input');

export const emitBlur = emit('blur');
